import mutations from './mutations';
import actions from './actions';
import getters from './getters';
export const getDefaultUserState = () => {
    return {
        id: null,
        customer_id: null,
        user_role: '',
        ssn: '',
        first_name: '',
        last_name: '',
        street_address: '',
        street_number: '',
        coaddress: '',
        zip: '',
        city: '',
        country: '',
        email: '',
        phone: null,
        cellphone: '',
        state: null,
        subscribe_to_marketing: null,
        non_swedish_postal_code: false,
        contact_person: {
            first_name: '',
            last_name: '',
            email: '',
            cellphone: ''
        },
        company: {
            name: '',
            organization_number: '',
            industry: '',
            department: '',
            street_address: '',
            street_number: '',
            zip: '',
            city: '',
            country: '',
            switchboard_number: '',
            signatory_first_name: '',
            signatory_last_name: '',
            signatory_phone: '',
            signatory_cellphone: '',
            signatory_email: '',
            notes: '',
        },
        agent_id: null,
        prevent_login: null,
        last_logged_in: '',
        created_at: '',
        updated_at: '',
        deleted_at: ''
    };
};
export const state = getDefaultUserState();
export const user = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
